import axios from '../../../../api/config'
import i18n from '../../../../i18n'
import {
  getExamsAPI,
  getExamAPI
} from '../../../../api/vocabularyAPI'

const state = {
  examList: [],
  currentExam: {
    id: null,
    glossary: '',
    book: '',
    lesson: '',
    range_start: '',
    range_end: '',
    block_size: ''
  }
}

const getters = {}

const mutations = {
  setExamList (state, data) {
    state.examList = data
  },
  setChosenExam (state, exam) {
    exam.book = exam.book === null ? i18n.t('Common.none') : exam.book
    exam.lesson = exam.lesson === null ? i18n.t('Common.none') : exam.lesson
    exam.range = `${i18n.t('Common.from')} ${exam.range_start} ${i18n.t('Common.to')} ${exam.range_end}`
    state.currentExam = exam
  },
  resetChosenExam (state) {
    state.currentExam = {
      id: null,
      glossary: '',
      book: '',
      lesson: '',
      range_start: '',
      range_end: '',
      block_size: ''
    }
  }
}

const actions = {
  getExams ({ commit }) {
    commit('glossary/setWaitForFetching', true, { root: true })
    return new Promise((resolve, reject) => {
      axios.get(getExamsAPI)
        .then((res) => {
          commit('setExamList', res.data.message)
          commit('glossary/setWaitForFetching', false, { root: true })
          resolve()
        })
    })
  },
  getExam ({ commit }, payload) {
    commit('glossary/setWaitForFetching', true, { root: true })
    return new Promise((resolve, reject) => {
      axios.get(`${getExamAPI}/${payload.examId}`)
        .then((res) => {
          commit('setChosenExam', res.data.message)
          commit('glossary/setWaitForFetching', false, { root: true })
          resolve()
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
